<template>
  <PrayerContainer :active-prayers="activePrayers" @stateChanged="stateChanged"></PrayerContainer>
</template>

<script>
  import PrayerContainer from "./prayer/PrayerContainer";

  export default {
    name: "PrayerTab",
    components: {PrayerContainer},
    props: {
      activePrayers: {
        type: Object,
        required: true,
        default() {
          return {}
        }
      }
    },
    methods: {
      stateChanged: function (prayer, state) {
        this.$emit('stateChanged', prayer, state)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabs/PrayerTab.vue